import React from 'react';

/* Icon declaration and export */
import { FontAwesomeIcon,FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { library,IconName,SizeProp,IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
library.add(fal);
library.add(fas);

const fontAwesomeLibrary: any = library;
export const falLibrary = Object.keys(fontAwesomeLibrary?.definitions.fal);

export interface Icon extends FontAwesomeIconProps {
  icon: IconName;
  size?: SizeProp;
  lib: IconPrefix;
  gradientType?: 'light' | 'dark';
}

export const  Icon = ({
  icon,
  size,
  lib,
  gradientType,  // default is light gradient for light mode components
  ...props
}: Icon) => {

  return (
    <>
      {gradientType === 'light' && (
        <svg className="gradient">
          <defs>
            <linearGradient id="linear" gradientTransform="rotate(45)">
              <stop offset="0%" stopColor="#5CB3CB"></stop>
              <stop offset="50%" stopColor="#00749A"></stop>
              <stop offset="100%" stopColor="#015A7E"></stop>
            </linearGradient>
          </defs>
        </svg>  
      )}
      {gradientType === 'dark' && (
        <svg className="gradient-dark">
          <defs>
            <linearGradient id="linear-dark" gradientTransform="rotate(45)">
              <stop offset="60%" stopColor="#FFFFFF"></stop>
              <stop offset="100%" stopColor="#36A4C6"></stop>
            </linearGradient>
          </defs>
        </svg>
      )}
      <FontAwesomeIcon
        icon={[lib, icon]}
        size={size}
        className="gradientSvg"
        {...props}
      />
    </>
  );
};


export default Icon;

export type Prefix = IconPrefix;
export type Name = IconName;
